export function getBuilderFilterLabel(builderName: string | undefined | null, builderId: number): string {
  if (!builderName) {
    return `Застройщик №${builderId}`;
  }

  const shouldAddBrackets = !(builderName.trim().startsWith('«') && builderName.trim().endsWith('»'));
  const formattedBuilderName = shouldAddBrackets ? `«${builderName}»` : builderName;

  return `Застройщик: ${formattedBuilderName}`;
}
